import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-compliance-status-cell',
    templateUrl: './compliance-status-cell.component.html',
    styleUrls: ['./compliance-status-cell.component.scss'],
    standalone: false
})
export class ComplianceStatusCellComponent {
  @Input() complianceStatus: string;
  @Input() daysPastCompliance: number;
  @Input() daysPastPolicyCompliance: number;

  readonly outOfCompliance: string = 'Out of Compliance';
  readonly atRisk: string = 'At Risk';
}
